import styled from "styled-components"
import Announcement from "../components/Announcement"
import Navbar from "../components/Navbar"
import Products from "../components/Products"
import Newsletter from "../components/Newsletter"
import Footer from "../components/Footer"
import { Link, Route, useLocation } from "react-router-dom"
import { useState } from "react"

const Container = styled.div`

`
const Title = styled.h1`
    margin: 20px;
`
const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
const Filter = styled.div`
    margin: 20px;
`

const FilterText = styled.span`
    font-size: 20px;
    font-weight: 600;
    margin-right: 20px;
`

const Select = styled.select`
    padding: 10px;
    margin-right: 20px;
`

const Option = styled.option`

`

const SearchContainer = styled.div`
    border: 0.5px solid lightgray;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin-left: 25px;
    padding: 5px;
    margin-right: 10px;
    width: 100px;
`

const Input = styled.input`
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
`

const ProductList = () => {
    const location = useLocation();
    const cat = location.pathname.split("/")[2];
    const [filters, setFilters] = useState({});
    const [sort, setSort] = useState("newest");
    const [searchTerm, setSearchTerm] = useState();

    const handleFilters = (e) => {
        const value = e.target.value.toLowerCase();
        setFilters({
            ...filters,
            [e.target.name]: value,
        });
        {(value==="all") ? document.location.href="/products/" : document.location.href="/products/" + value;}
        //document.location.href="/products/" + value;
    }

  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <FilterContainer>
            <Title>Products</Title>
            <SearchContainer>
                {/* <input id='searchInput' type="text" placeholder='Search' onChange={(e) => {setSearchTerm(e.target.value)}}/> */}
                <Input placeholder="Search" type="text" onChange={(e) => {
                    setSearchTerm(e.target.value)
                }}/>
            </SearchContainer>
        </FilterContainer>
        <FilterContainer>
            <Filter>
                <FilterText>
                    Filter Products:
                </FilterText>
                <Select name="categories" onChange={handleFilters}>
                    <Option selected disabled>
                        Product Type
                    </Option>
                    <Option>All</Option>
                    <Option>Food</Option>
                    <Option>Beer</Option>
                    <Option>Soft Drinks</Option>
                    <Option>Clothing</Option>
                    <Option>Household Goods</Option>
                    <Option>Cigarettes</Option>
                </Select>
            </Filter>
            <Filter>
                <FilterText>
                    Sort Products:
                </FilterText>
                <Select onChange={e=>setSort(e.target.value)}>
                    <Option value="newest">Newest</Option>
                    <Option value="asc">Price (lowest)</Option>
                    <Option value="desc">Price (highest)</Option>
                </Select>
            </Filter>
        </FilterContainer>
        <Products cat={cat} filters={filters} sort={sort} search={searchTerm}/>
        <Newsletter/>
        <Footer/>
    </Container>
  )
}

export default ProductList